import { Component } from '@angular/core';

@Component({
  selector: 'fz-root',
  template: `<router-outlet></router-outlet>`,
})
export class AppComponent {}
